/* eslint-disable no-restricted-imports */
import { trackPageView, sendEvent, sendEventElementShown, sendVkConversion, sendDv360Conversion } from './analytics';
import { sendHHEvent, sendHHEventButtonClick, sendHHEventElementShown, AnalyticsParams } from './hhAnalytics';
import addEventPixels from './pixels';

declare global {
    interface GlobalAnalyticsParams extends AnalyticsParams {
        hhtmSource: string;
        hhtmFrom: string;
    }
    interface GlobalFeatures {
        disable_counters: boolean; // eslint-disable-line camelcase
    }
    interface GlobalVars {
        features: GlobalFeatures;
        analyticsParams: GlobalAnalyticsParams;
        build: string;
        requestId: string;
        countersDisabled?: boolean;
    }
    interface Window {
        globalVars: GlobalVars;
        gtag(
            action: string,
            event: string | { page_location: string; send_page_view: boolean } | { transport_type: string }, // eslint-disable-line camelcase
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            data?: Record<string, any>
        ): void;
        ymtag(method: 'hit' | 'reachGoal', data: string): void;
        fbq(event: string, data: string): void;
        VK: {
            Retargeting: {
                Event(params: string): void;
            };
        };
        VKPixelRW: {
            Goal(params: string): void;
        };
        vkPixelLoadedCallback(): void;
        tmrReachGoal(category: string, event: string, label?: string, params?: Record<string, unknown>): void;
        tmrPageView(): void;
    }
}

const Analytics = {
    trackPageView,
    sendEvent,
    sendEventElementShown,
    sendHHEvent,
    sendHHEventButtonClick,
    sendHHEventElementShown,
    sendVkConversion,
    sendDv360Conversion,
    addEventPixels,
};

export default Analytics;

export { default as useElementShown } from './useElementShown';
export { default as useSendOnChanged } from './useSendOnChanged';
export { default as ElementShownAnchor } from './ElementShownAnchor';
export { default as VendorAnalytics } from './vendorAnalytics';
